import { Directive, inject } from "@angular/core";
import { AbstractControl } from "@angular/forms";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import { CrudDialogBase } from "src/app/controls/base/crud-dialog.base";
import { SelectedItem } from "src/app/controls/models/selected-item.interface";
import { StageResultsTableService } from "../services/stage-results-table.service";
import { StageBaseEntity } from "../models/stage-base-entity.interface";
import { StageResultBaseEntity } from "../models/stage-result-base.entity.interface";

@Directive()
export abstract class StageResultBase<T extends { [K in keyof T]: AbstractControl<any, any>; }, Entity extends StageResultBaseEntity> extends CrudDialogBase<T, Entity> {

    /** Registered crews reference */
  protected crews: SelectedItem[] = [];

  /** flag for sorting the crew numbers by registration or math */
  protected sortByRegistration = true;

  /** Original crew numbers order reference */
  protected originalCrewNumbersOrder: SelectedItem[] = [];

  /** Stage result service reference */
  private stageResultService = inject(StageResultsTableService);

  /** Stage name reference */
  protected stageName: string | null = null;

  /** Stage id reference */
  protected stageId: number | null = null;

  /** Stage result id reference */
  protected stageResultId: number | null = null;

  /**
   * Loads the default values for the driving report creation
   */
  protected loadDefaultValues(): void {
    if (this.id || this.stageResultId || !this.stageId) {
      return;
    }

    /** gets the crews registered in competition */
    this.stageResultService.getAvailableCrews(this.stageId).subscribe((crews: SelectedItem[]) => {
      this.crews = crews;
      this.originalCrewNumbersOrder = crews;
    })
  }

  /**
   * Initializes the stage id and stage name
   * @param data the stage id and stage name reference
   */
  protected override beforeDialogShow(data: StageBaseEntity): void {
    this.stageId = data.stageId;
    this.stageName = data.stageName;
    this.loadDefaultValues();
  };

  /**
   * Prefills the data after data obtain
   * @param data the obtained data reference
   */
  protected override afterDataPrefill(data: Entity): void {
    if (!data) {
      return;
    }
    
    this.crews = data.crews;
    this.originalCrewNumbersOrder = data.crews;
    this.stageResultId = data.stageResultId ?? this.id;
    this.formGroup.get('crewId').disable();

    /** slows down the patching to patch all data */
    setTimeout(() => {
      this.fillFormGroup(data);
    });
  };

  /**
   * Overridable method for filling the form group
   * @param data the stage result base entity reference
   */
  protected fillFormGroup(data: StageResultBaseEntity): void {}

    /**
   * Sorts crew numbers according to crew number(true) / registration order (false)
   * @param event the event to process toggle checked status 
   */
  protected sortCrewNumbers(event: MatSlideToggleChange): void {
    if (event.checked) {
      /** sorts crew number according to mathematics */
      this.crews.sort((a, b) => a.text.localeCompare(b.text));
      this.sortByRegistration = false;
      return;
    }

    /** sorts crew numbers according to registration order */
    this.crews = this.originalCrewNumbersOrder;
    this.sortByRegistration = true;
  }
}